<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>用户分组人数分布</span>
      </div>

      <el-form ref="queryForm" :model="queryParams" :inline="true">
        <el-form-item label="开始日期" prop="startDate">
          <el-date-picker
            v-model="queryParams.startDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="结束日期" prop="endDate">
          <el-date-picker
            v-model="queryParams.endDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" :loading="loading" size="mini" @click="handleQuery">查询</el-button>
          <el-button icon="el-icon-download" size="mini" :loading="loading" @click="exportData()">导出</el-button>
        </el-form-item>
      </el-form>

      <el-table
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="date"
          label="日期"
          width="120px"
          align="center"
        />
        <el-table-column
          v-for="(item , index) in tableHeader"
          :key="index"
          align="center"
          :label="item.label"
          :formatter="numFormatter"
        >
          <template scope="scope">
            <span v-if="scope.row.data[item.value]">{{ scope.row.data[item.value].count }} </span>
            <span v-else>0</span>
          </template>
        </el-table-column>
      </el-table>

      <UserSpinStat ref="stat" class="mtop" :show-header="false" />
    </el-card>

  </div>
</template>

<script>
import { getUserGroupStat } from '@/api/statistics/user_remain'
import { getLastDates, scientificFormat } from '@/utils'
import UserSpinStat from '@/views/config/user-spins/comments/user-spin-echart-stat.vue'

export default {
  name: 'UserGroup',
  components: {
    UserSpinStat
  },
  data() {
    return {
      loading: false,
      tableHeader: [],
      spinLevelData: [],
      tableData: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        type: 0
      }
    }
  },
  created() {
    if (!this.queryParams.startDate) {
      this.queryParams.startDate = getLastDates(7)
    }
    if (!this.queryParams.endDate) {
      this.queryParams.endDate = getLastDates(1)
    }
    this.getTables()
  },
  methods: {
    handleQuery(select = true) {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }

      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }
      if (select) {
        this.getTables()
      }
    },
    getTables() {
      this.loading = true
      this.queryParams.type = 0
      getUserGroupStat(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableHeader = []
          this.tableData = res.data.data
          if (this.tableData.length > 0) {
            for (const i in this.tableData[0].data) {
              const val = this.tableData[0].data[i]
              this.tableHeader.push({ label: val.title, value: val.group_id })
            }
          }
          this.$refs.stat.groupStat(this.tableData)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData() {
      this.queryParams.type = 1
      getUserGroupStat(this.queryParams).then(res => {
        if (res.code === 200) {
          if (res.data.path) {
            window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          }

          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    numFormatter(col, row, val) {
      return scientificFormat(val)
    }
  }

}
</script>

<style scoped>
.mtop{
  margin-top: 10px
}
</style>
